import {ReactComponent as actions} from "src/assets/icons/app/actions.svg";
import {ReactComponent as businessDiagnosis} from "src/assets/icons/app/businessDiagnosis.svg";
import {ReactComponent as strategicPlanning} from "src/assets/icons/app/strategicPlanning.svg";
import {ReactComponent as projects} from "src/assets/icons/app/projects.svg";
import {ReactComponent as financialManagement} from "src/assets/icons/app/financialManagement.svg";
import {ReactComponent as indicators} from "src/assets/icons/app/indicators.svg";
import {ReactComponent as analysis} from "src/assets/icons/app/analysis.svg";
import {ReactComponent as audits} from "src/assets/icons/app/audits.svg";
import {ReactComponent as configs} from "src/assets/icons/app/configs.svg";
import {ReactComponent as meeting} from "src/assets/icons/app/meeting.svg";
import {ReactComponent as occurrences} from "src/assets/icons/app/occurrences.svg";
import {ReactComponent as risks} from "src/assets/icons/app/risks.svg";
import {ReactComponent as reports} from "src/assets/icons/app/reports.svg";
import {ReactComponent as trash} from "src/assets/icons/app/trash.svg";
import { AppIconTypes } from "./interface";

type IAppIcons = {
    [key in AppIconTypes]: any;
};

const appIcons: IAppIcons = {
	actions,   
	analysis, 
	audits,
	businessDiagnosis,
	configs,
	financialManagement,
	indicators,
	meeting,
	occurrences,
	projects,
	reports,
	risks,
	strategicPlanning,
	trash
};

export default appIcons;
